import "./App.css";
import "./ResponsiveText.css";
import Sine from "./components/Sine";
import Window from "./components/Window";

function App() {
  return (
    <div className="App">
      <Sine />
      <Window />
    </div>
  );
}

export default App;